import axios from 'axios';
import Setting from '@/setting';
import store from '@/store';
import { Notice } from 'view-ui-plus'
import router from '@/router'

// 创建一个 axios 实例
const service = axios.create({
    baseURL: Setting.baseUrl,
    timeout: Setting.timeout, // 请求超时时间
});

// 请求拦截器
service.interceptors.request.use(
    (config) => {
        // 让每个请求携带token
        const isToken = (config.headers || {}).isToken === false;
        let token = store.getters.getToken
        if (token && !isToken) {
            config.headers['Authorization'] = 'Bearer ' + token; // token
        }
        return config;
    },
    (error) => {
        Notice.open({
            title: '温馨提示',
            desc: error
        });
    }
);

// 响应拦截器
service.interceptors.response.use(
    (response) => {
        // dataAxios 是 axios 返回数据中的 data
        const dataAxios = response.data;
        // 这个状态码是和后端约定的
        const { code } = dataAxios;
        // 根据 code 进行判断
        if (code === undefined) {
            // 如果没有 code 代表这不是项目后端开发的接口
            return dataAxios;
        } else if (code == 0) {
            return dataAxios;
        } else if (code == 401) {
            Notice.open({
                title: '温馨提示',
                desc: dataAxios.msg ? dataAxios.msg : dataAxios.message
            });
            router.replace('/login')
        } else {
            Notice.open({
                title: '温馨提示',
                desc: dataAxios.msg ? dataAxios.msg : dataAxios.message
            });
            return dataAxios;
        }
    },
    (error) => {
        if (error && error.response) {
            const dataAxios = error.response.data;
            Notice.open({
                title: '温馨提示',
                desc: dataAxios.msg ? dataAxios.msg : dataAxios.error ? dataAxios.error : dataAxios.message
            });
            return dataAxios;
        } else {
            Notice.error({
                title: '网络请求超时'
            });
            return { code: 500 }
        }
    }
);

export default service;